import axios from '@axios';
import { ErrorMessage } from '@/libs/Error';

export default class SLSDevolucaoClient {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  async listar(params = {}) {
    try {
      const cleaned = {};
      Object.entries(params).forEach(([k, v]) => {
        if (v !== undefined && v !== null && v !== '') cleaned[k] = v;
      });
      return await this.api.get('/devolucoes', { params: cleaned });
    } catch (err) {
      this.error.errorShow(err);
      throw err;
    }
  }

  async buscarPorId(id) {
    try {
      return await this.api.get(`/devolucoes/${id}`);
    } catch (err) {
      this.error.errorShow(err);
      throw err;
    }
  }

  async criar(data) {
    try {
      return await this.api.post('/devolucoes', data);
    } catch (err) {
      this.error.errorShow(err);
      throw err;
    }
  }

  async atualizarStatus(id, { status, observacao }) {
    try {
      return await this.api.patch(`/devolucoes/${id}/status`, { status, observacao });
    } catch (err) {
      this.error.errorShow(err);
      throw err;
    }
  }

  async buscarPedidoItens(pedidoid) {
    try {
      return await this.api.get(`/devolucoes/pedido-itens/${pedidoid}`);
    } catch (err) {
      this.error.errorShow(err);
      throw err;
    }
  }
}
